import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {Box, Flex, Text} from 'rebass';
import {InlineBlock, Popover} from "reakit";
import {Span} from "../Base";
import Filters from './StudentFilters'
import IosArrowUp from 'react-ionicons/lib/IosArrowUp'
import IosArrowDown from 'react-ionicons/lib/IosArrowDown'

import {schoolSelectors} from "../../store/school";


function StudentFilterDropdown(props) {
	const {titleColor, clearFilter, updateFilters, dormView,  isCheckin, checkinFilters, title, rosters, rosterFilter, updateRosterFilter, handleDeleteRoster, noLocation} = props;
	let {filters} = props;
	if(!filters.type){
		filters = {
			...filters,
			type: []
		}
	}
	let showClear = false
	if(title !== 'All Students'){
		showClear = true

	}
	return (
		<Popover.Container>
			{popover => (
				<InlineBlock relative>
					<Flex onClick={popover.toggle}>
						<Box><Text fontWeight={700} color={titleColor}>{title} {showClear &&
						<Span onClick={clearFilter} color={'blue'}>Clear</Span>}</Text></Box>
						<Box>
							{popover.visible ? <IosArrowUp style={{ display: 'block' }}  {...popover} color={titleColor}/> :
								<IosArrowDown style={{ display: 'block' }} {...popover} color={titleColor}/>}

						</Box>
					</Flex>

					<Popover fade slide expand hideOnClickOutside {...popover} padding={0} margin={0} borderRadius={0}>
						<Filters 
							noLocation={noLocation}
							handleUpdate={updateFilters} 
							dormView={dormView} 
							filters={filters} 
							isCheckin={isCheckin} 
							checkinFilters={checkinFilters}
							rosters={rosters}
							rosterFilter={rosterFilter}
							updateRosterFilter={updateRosterFilter}
							handleDeleteRoster={handleDeleteRoster}
						/>
					</Popover>
				</InlineBlock>
			)}
		</Popover.Container>
	);
}

StudentFilterDropdown.propTypes = {
	dormView: PropTypes.bool,
	noLocation: PropTypes.bool,
	filters: PropTypes.object,
	updateFilters: PropTypes.func,
	title: PropTypes.string,
	titleColor: PropTypes.string,
	clearFilter: PropTypes.func
};

StudentFilterDropdown.defaultProps = {
	filters: {
		grade: [],
		location: [],
		dorm: [],
		gender: [],
		type: []
	},
	updateFilters: (filters) => console.log('updating filters',filters),
	clearFilter: () => console.log('clearing filters'),
	title: "Apply Filters",
	titleColor: 'black',
	dormView: false,
	noLocation: false
};

const mapStateToProps = (state) => ({
	school: schoolSelectors.refreshSchool(state.school),
	isLoading: schoolSelectors.isLoading(state.school)
});

export default connect(mapStateToProps)(StudentFilterDropdown);
